/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AzureDevOpsListBuildRequests {
    getFixupPrototypeFunction() { return AzureDevOpsListBuildRequests.fixupPrototype; }

    static newInstance(model: Partial<AzureDevOpsListBuildRequests>): AzureDevOpsListBuildRequests {
        let obj = Object.assign(new AzureDevOpsListBuildRequests(), model);
        AzureDevOpsListBuildRequests.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AzureDevOpsListBuildRequests>): AzureDevOpsListBuildRequests {
        if (!model) return null;
        return AzureDevOpsListBuildRequests.newInstance(<AzureDevOpsListBuildRequests> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AzureDevOpsListBuildRequests) {
        if (!obj) return;

        models.AzureDevOpsListBuildRequests.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AzureDevOpsListBuildRequests): boolean {
        Object.setPrototypeOf(obj, AzureDevOpsListBuildRequests.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.pipeline_id === undefined) {
            this.pipeline_id = 0;
        }
    }

    /**
     * Service Account ID
     */
    service_account_id: string;

    /**
     * Azure Devops Project ID
     */
    project_id: string;

    /**
     * Azure Devops Pipeline ID
     */
    pipeline_id: number;

    /**
     * Filter the list of builds response based on the status
     */
    status: models.AzureDevOpsPipelineBuildStatus;

    /**
     * Criteria to sort the builds in the response
     */
    query_order: models.AzureDevOpsBuildQueryOrder;

    /**
     * filter the build response with the provided search keyword
     */
    search: string;

}
